import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'src/funnels/common/styles/index.scss';
import { initSentry } from 'common/config/sentry';
import { SentryErrorBoundary } from 'common/components/SentryErrorBoundary/SentryErrorBoundary';
import { ProjectType } from 'common/types';

initSentry(ProjectType.FUNNELS);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <SentryErrorBoundary showError>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </SentryErrorBoundary>,
);
